
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 26.25V5.75A1.752 1.752 0 0 0 26.25 4H5.75A1.752 1.752 0 0 0 4 5.75v20.5A1.752 1.752 0 0 0 5.75 28h20.5A1.752 1.752 0 0 0 28 26.25ZM26.25 5.5a.25.25 0 0 1 .25.25v3.432A4.496 4.496 0 0 1 22.817 5.5h3.433Zm-4.948 0a6.005 6.005 0 0 0 5.198 5.198v4.552h-4.552a6.005 6.005 0 0 0-5.198-5.198V5.5h4.552ZM11.5 16a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm3.75-10.5v4.552a6.005 6.005 0 0 0-5.198 5.198H5.5v-4.552A6.005 6.005 0 0 0 10.698 5.5h4.552Zm-9.75.25a.25.25 0 0 1 .25-.25h3.432A4.496 4.496 0 0 1 5.5 9.182V5.75Zm.25 20.75a.25.25 0 0 1-.25-.25v-3.433A4.497 4.497 0 0 1 9.182 26.5H5.75Zm4.948 0A6.005 6.005 0 0 0 5.5 21.302V16.75h4.552a6.005 6.005 0 0 0 5.198 5.198V26.5h-4.552Zm6.052 0v-4.552a6.005 6.005 0 0 0 5.198-5.198H26.5v4.552a6.005 6.005 0 0 0-5.198 5.198H16.75Zm9.75-.25a.25.25 0 0 1-.25.25h-3.433a4.497 4.497 0 0 1 3.683-3.683v3.433Z"}})])
          )
        }
      }
    